export enum AddClaimantModalSteps {
  RelationshipInfo = 'relationshipInfo',
  PersonDetails = 'personDetails',
  BusinessDetails = 'businessDetails',
  AddressInfo = 'addressInfo',
  ContactInfo = 'contactInfo',
  PaymentInfo = 'paymentInfo',
}

export enum AddClaimantSteps {
  FIRST_STEP,
  SECOND_STEP,
}
